<template>
    <v-sheet class="smc-sheet-transparent workshop-slider">
        <p class="slider-heading">Our workshop partners</p>
        <div class="marquee-wrapper">
            <div class="fade-overlay fade-left"></div>
            <div class="fade-overlay fade-right"></div>
            <div
                class="marquee-track"
                :class="{ paused }"
                @mouseenter="paused = true"
                @mouseleave="paused = false"
            >
                <div v-for="(item, i) in doubledLogos" :key="i" class="logo-cell">
                    <img :src="item.src" alt="Workshop partner logo" />
                </div>
            </div>
        </div>
    </v-sheet>
</template>

<script>
export default {
    data() {
        return {
            paused: false,
            workshopLogos: [
                { src: require('@/assets/images/partner-logos/slider-1.jpg') },
                { src: require('@/assets/images/partner-logos/slider-2.jpg') },
                { src: require('@/assets/images/partner-logos/slider-3.jpg') },
                { src: require('@/assets/images/partner-logos/slider-4.jpg') },
                { src: require('@/assets/images/partner-logos/slider-5.jpg') },
                { src: require('@/assets/images/partner-logos/slider-6.jpg') },
                { src: require('@/assets/images/partner-logos/slider-7.jpg') },
                { src: require('@/assets/images/partner-logos/slider-8.jpg') },
                { src: require('@/assets/images/partner-logos/slider-9.jpg') },
                { src: require('@/assets/images/partner-logos/slider-10.jpg') },
                { src: require('@/assets/images/partner-logos/slider-11.jpg') },
                { src: require('@/assets/images/partner-logos/slider-12.jpg') },
                { src: require('@/assets/images/partner-logos/slider-13.jpg') },
                { src: require('@/assets/images/partner-logos/slider-14.jpg') },
                { src: require('@/assets/images/partner-logos/slider-15.jpg') },
            ],
        };
    },
    computed: {
        doubledLogos() {
            return [...this.workshopLogos, ...this.workshopLogos];
        },
    },
};
</script>

<style scoped>
@import "../../assets/scss/vuetify-elements/sheet.scss";

.workshop-slider {
    padding: 48px 0 56px;
    overflow: hidden;
}

.slider-heading {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 700;
    letter-spacing: 2px;
    color: #888;
    margin-bottom: 36px;
}

.marquee-wrapper {
    position: relative;
    overflow: hidden;
}

.fade-overlay {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100px;
    z-index: 2;
    pointer-events: none;
}

.fade-left {
    left: 0;
    background: linear-gradient(to right, #fff 0%, transparent 100%);
}

.fade-right {
    right: 0;
    background: linear-gradient(to left, #fff 0%, transparent 100%);
}

.marquee-track {
    display: flex;
    align-items: center;
    width: max-content;
    animation: marquee 40s linear infinite;
    will-change: transform;
}

.marquee-track.paused {
    animation-play-state: paused;
}

@keyframes marquee {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); }
}

.logo-cell {
    width: 160px;
    height: 80px;
    margin: 0 24px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.25s ease;
}

.logo-cell:hover {
    transform: scale(1.1);
}

.logo-cell img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
}
</style>
